import React, { useState, useEffect } from "react";
import { Form, InputGroup, Modal, NavItem } from "react-bootstrap";
import { BiSearch } from "react-icons/bi";
import { casinoTabs } from "../../lib/data/casinoTabs.data";
import { casinoProvidersGamesdata } from "../../lib/data/casinoProvidersGamesdata";
import { SlotGames } from "../../lib/data/SlotGames.data";
import { KingmakerGames } from "../../lib/data/KingmakerGames.data";
import { auraGames } from "../../lib/data/auraGames.data";
import { altGaming } from "../../lib/data/altGaming.data";

import SearchIcon from "../../assets/images/icons/search.webp";
import { casinoSection } from "../../lib/data/casinoSection.data";

const SEARCH_TYPES = {
  SLOTS: "slots",
  AURA: "aura",
  HOME: "home",
  KINGMAKER: "kingmaker",
  GAP: "alt-gaming",
};

const GamesSearchModal = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [filteredData, setFilteredData] = useState(null);
  const [searchText, setSearchText] = useState(false);
  const isLandingPage = window.location.pathname === "/";

  const totalGames = [
    // Home page Games
    ...Object.values(Object.values(casinoTabs?.colorprediction)),
    ...Object.values(casinoTabs?.popular),
    ...Object.values(casinoTabs?.aura),
    ...Object.values(casinoTabs?.slotsgames),
    ...Object.values(casinoTabs?.exclusive),
    ...Object.values(casinoTabs?.auracardgames),
    ...Object.values(casinoTabs?.spribe),
    // casino page Games
    ...Object.values(casinoSection?.popularGames),
    ...Object.values(casinoSection?.roulettetab),
    ...Object.values(casinoSection?.AndarBahar),
    ...Object.values(casinoSection?.blackjacktab),
    ...Object.values(casinoSection?.baccarattab),
    ...Object.values(casinoSection?.livecasino),
    ...Object.values(casinoSection?.tablegame),
    ...Object.values(casinoSection?.dragontiger),
    // Alt Gaming Pages
    ...Object.values(altGaming?.jiliGaming),
    ...Object.values(altGaming?.mac88Gaming),
    ...Object.values(altGaming?.mac88Gaminglive),
    //Slots Page Games
    ...Object.values(SlotGames?.netenttab?.slide1),
    ...Object.values(SlotGames?.redtigertab?.slide2),
    ...Object.values(SlotGames?.netenttab?.slide2),
    ...Object.values(SlotGames?.redtigertab?.slide1),
    //Kingmaker Page Games
    ...Object.values(KingmakerGames?.kingmakerGames?.slide1),
  ];

  useEffect(() => {
    return () => {
      setFilteredData(null);
    };
  }, []);

  const handleClose = () => {
    setFilteredData(null);
    setShow(false);
  };

  // const filterPageSpecificData = (
  //   dataToFilter,
  //   searchValue,
  //   searchType = "pageSpecific",
  // ) => {
  //   let localFilter = [];
  //   let filteredCategories = [
  //     "netenttab",
  //     "redtigertab",
  //     "jiliGaming",
  //     "mac88Gaming",
  //     "mac88Gaminglive",
  //     "improvedExperience",
  //     "cardGames",
  //     "virtualCardGames",
  //     "instantGames",
  //   ];

  //   Object.entries(dataToFilter).map(([key, value]) => {
  //     if (
  //       filteredCategories.includes(key) ||
  //       window.location.pathname.toLowerCase().indexOf(SEARCH_TYPES.KINGMAKER) >
  //         -1 ||
  //       searchType === "all"
  //     ) {
  //       Object.values(value).map((item) => {
  //         console.log("item", item);
  //         if (item?.name) {
  //           if (
  //             item?.name?.toLowerCase().indexOf(searchValue?.toLowerCase()) > -1
  //           ) {
  //             localFilter.push(item);
  //           }
  //         } else if (typeof item === "object") {
  //           Object.values(item).map((f) => {
  //             if (
  //               f?.name?.toLowerCase().indexOf(searchValue?.toLowerCase()) > -1
  //             ) {
  //               localFilter.push(f);
  //             }
  //           });
  //         }
  //       });
  //     }
  //   });
  //   return localFilter;
  // };

  const handleSearch = (value) => {
    if (value) {
      let filteredValue = [];

      /**  gamesData for making games to be get filtered according to page wise */

      // if (
      //   window.location.pathname.toLowerCase().indexOf(SEARCH_TYPES.SLOTS) > -1
      // ) {
      //   filteredValue = filteredValue.concat(
      //     filterPageSpecificData(SlotGames, value),
      //   );
      // }
      // else if (window.location.pathname.indexOf(SEARCH_TYPES.AURA) > -1) {
      //   filteredValue = filteredValue.concat(
      //     filterPageSpecificData(auraGames, value),
      //   );
      // }
      // else if (window.location.pathname.indexOf(SEARCH_TYPES.KINGMAKER) > -1) {
      //   filteredValue = filteredValue.concat(
      //     filterPageSpecificData(KingmakerGames, value),
      //   );
      // } else if (window.location.pathname.indexOf(SEARCH_TYPES.GAP) > -1) {
      //   filteredValue = filteredValue.concat(
      //     filterPageSpecificData(altGaming, value),
      //   );
      // } else {

      /** filtered games for common games search */
      Object.values(totalGames).map((item) => {
        if (
          item?.name?.toLowerCase().trim().indexOf(value?.toLowerCase()) > -1
        ) {
          filteredValue.push(item);
        }
      });

      // }

      /* filtering out duplicates data */
      const uniqueDataArray = new Set();
      const uniquefilteredValue = filteredValue.filter(
        (item) =>
          !uniqueDataArray.has(item.redirectUrl) &&
          uniqueDataArray.add(item.redirectUrl),
      );

      setFilteredData(uniquefilteredValue);
    }
  };

  return (
    <>
      <div className="search-box">
        <div className="searchGames" onClick={handleShow}>
          <img src={SearchIcon} />
        </div>
      </div>

      <Modal show={show} onHide={handleClose} className="search-modal">
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>Search Games</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3 search-icon">
            <Form.Control
              placeholder="Search your favourite games here..."
              aria-label="Text input with dropdown button"
              type="search"
              onChange={(e) => handleSearch(e.target.value)}
              autoFocus
            />
          </InputGroup>

          <ul className="game-list">
            {filteredData &&
              filteredData.map((item, idx) => (
                <li key={idx}>
                  <a href={item?.href || item.redirectUrl}>
                    <img src={item.imgUrl} />
                    <span>{item.name}</span>
                  </a>
                </li>
              ))}
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GamesSearchModal;
